import React from 'react';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { Card, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Modal,Button } from 'react-bootstrap';



function AffichageEquipeMatch(props) {

  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [match,setMatch] = useState(null)
  const {idEquipe, nomEquipe} = useParams();
  const Navigate = useNavigate();
  const [pasDispo, setPasDispo] = useState(false)
  const apiUrl = process.env.REACT_APP_API_URL;

  

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/match/affichage/${idEquipe}`,
        );
        setMatch(response.data);
        setError(null);
        setIsLoading(false);


      } catch (error) {
        if (error.response) {
          if (error.response.status === 404) {
              setPasDispo(true);
          } else {
              setError(error.response.data.message);
          }
      } else {
          setError(true);
      }
      setIsLoading(false);

      }
    };

    fetchData(); 
  }, [idEquipe, Navigate, apiUrl]);




    if (isLoading) {
         return (
          <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
          </div>
          
          );  
        }




  return (
  <>
  {pasDispo && (
        <Modal show={pasDispo} onHide={() => Navigate('/arbitre/tableau-de-bord/match')}>
                <Modal.Header closeButton>
                  <Modal.Title>Aucun match trouvé pour cette équipe</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <>Aucun match trouvé pour <strong>{nomEquipe}</strong>.</>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary"  onClick={() => Navigate('/arbitre/tableau-de-bord/match')} >
                    Quitter
                  </Button>
                </Modal.Footer>
        </Modal>
    )
    
    }
  {props.userData && match ? (
    <>
      <div className="joueur equipe">
          <div className="image7"><img src='/img/bel.png'  alt="logo de l'union Belge de football" width="100" height="100"/></div>
          <div className="nom"><a href={`/arbitre/tableau-de-bord/equipe/${idEquipe}`}><span style={{textTransform : 'capitalize'}}>{nomEquipe}</span></a></div>
          <div className="nbr">  {match && match.competition.map((item, index) => (
            <strong key={index}>
              {item.competition}
              {index !== match.competition.length - 1 && ', '}
            </strong>
          ))}
          </div>
          <br/>
      </div>
      <hr></hr>
      <Row xs={1} md={2} className="g-4">
            {match && match.match.map((item, index) => (
              <Col key={index}>
                <Card className="text-center mx-auto" style={{ maxWidth: '500px'}}>
                  <Card.Header><strong><img style={{ width: '40px' }} src="/img/bel.png" alt='logo de la compétition' />{item.competition}</strong></Card.Header>
                  <Card className="text-center">
                    <Card.Body style={{borderRadius : '0px' }}>
                      <Card.Title>{item.equipe_dom} {item.score === null ? (<>-</>):(<>{item.score}</>)} {item.equipe_ext}</Card.Title>
                      <Card.Text>
                        {item.date}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Card>
                <br />
              </Col>
            ))}
          </Row>
        </>
      ) :(
        <>
      <div id="alert-message" className="alert" >
          <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
      </div></>
      )}
  </>
  );
}

export default AffichageEquipeMatch;
